import { render } from "./TableIcon.vue?vue&type=template&id=4f923e50"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/TableIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f923e50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f923e50', __exports__)) {
    api.reload('4f923e50', __exports__)
  }
  
  module.hot.accept("./TableIcon.vue?vue&type=template&id=4f923e50", () => {
    api.rerender('4f923e50', render)
  })

}


export default __exports__